import { Injectable, inject } from "@angular/core";
import {ILocalAttachmentDto} from "@shared/components/attachments/interfaces/orga-attachment-dto-extend.interface";
import {AttachmentTypes} from "@server-models";
import {AttachmentsActions} from "@shared/components/attachments/store/attachments.actions-type";
import {select, Store} from "@ngrx/store";
import {firstValueFrom, Observable, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {
  selectAttachmentsIsLoading,
  selectAttachmentsLoadingId
} from "@shared/components/attachments/store/attachments.selectors";
import {Router} from "@angular/router";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root',
})
export class SharedAttachmentsService {
  private _store = inject(Store);
  private _router = inject(Router);


  isLoading$: Observable<boolean>;
  loadingId$: Observable<string | null>;

  constructor() {
    this.isLoading$ = this._store.pipe(select(selectAttachmentsIsLoading));
    this.loadingId$ = this._store.pipe(select(selectAttachmentsLoadingId));
  }

  /**
   * @name checkLoadingButton
   * @description
   * Check if it is isLoading base on an id
   * @memberof SharedAttachmentsService
   * @param loadingId
   * @returns {Observable<boolean>}
   */
  checkLoadingButton(loadingId: string | undefined): Observable<boolean> {
    return this.loadingId$.pipe(
      withLatestFrom(this.isLoading$),
      map(([currentLoadingId, isLoading]) => loadingId === currentLoadingId && isLoading)
    );
  }

  /**
   * @name dispatchAction
   * @description
   * dispatch the action checking the attachment types
   * @memberof SharedAttachmentsService
   * @param attachment
   */
  dispatchAction(attachment: ILocalAttachmentDto): void {
    switch (attachment.type) {
      case AttachmentTypes.File:
        this._store.dispatch(AttachmentsActions.getFile(
          {
            path: attachment.url!,
            name: attachment.name!,
            loadingId: attachment.loadingId!,
            mineType: attachment.mimeType
          }
        ));
        break;
      case AttachmentTypes.Link:
        this._store.dispatch(AttachmentsActions.openLink({
          loadingId: attachment.loadingId!,
          url: attachment.url!
        }))
        break;
      case AttachmentTypes.Knowledge:
        this._store.dispatch(AttachmentsActions.getKnowledgeArticle({
          loadingId: attachment.loadingId!,
          referenceId: attachment.referenceId!
        }));
        break;
      case AttachmentTypes.Folder:
        firstValueFrom(this._store.select(SharedLoginSelectors.selectAppSegment)).then((appSegment) => {
          if(appSegment !== 'link') {
            this._router.navigate([appSegment, 'logged', 'documents'], {
              queryParams: {
                path: attachment.path!
              }
            });
          }
        });
        break;
    }
  }
}
